module.exports = __webpack_public_path__ + "img/restauration-kitchen.8b76f294.jpg";